import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "x-t-cell-txt-editor x-cell-editor"
};
const _hoisted_2 = {
  key: 0,
  class: "error-msg"
};
const _hoisted_3 = {
  key: 1,
  class: "x-cell-editor"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  return $props.editMode ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: _normalizeClass({
      'inner-border': true,
      'input-error': $props.error
    })
  }, [_createVNode(_component_a_input, {
    bordered: $setup.isFocused,
    value: $props.value,
    style: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      padding: '1px 5px'
    },
    "onUpdate:value": $setup.handleUpdateValue,
    onBlur: $setup.handleBLur,
    onFocus: $setup.handleFocus
  }, {
    prefix: _withCtx(() => [_renderSlot(_ctx.$slots, "prefix")]),
    suffix: _withCtx(() => [_renderSlot(_ctx.$slots, "suffix")]),
    _: 3
  }, 8, ["bordered", "value", "onUpdate:value", "onBlur", "onFocus"]), $props.error ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.error), 1)) : _createCommentVNode("", true)], 2)])) : (_openBlock(), _createElementBlock("span", _hoisted_3, [_createElementVNode("span", {
    class: _normalizeClass({
      'input-error': !!$props.error
    })
  }, _toDisplayString($props.value), 3)]));
}